<template>
  <div>
    <div
        class="sessionCard mt-5"
        @click="$router.push({name: 'tests'})"
    >
    <div class="d-flex flex-column justify-space-around fill-height">
      <div>
        <div
            class="sessionCardInfo d-flex justify-space-between"
            :class="$vuetify.breakpoint.mdAndDown && 'flex-column'"
        >
          <div class="mt-4 therapistName" v-if="session.doctor">
            <div class="therapistImage d-flex">
              <div>
                <img
                    :src="session.doctor.avatar || require('../../assets/gender/OTHER.svg')"
                    alt=""
                />
                <br />
                <div class="text-center" v-if="session.doctor.resume_link">
                  <v-btn
                      text
                      x-small
                      color="#3CBE8B"
                      elevation="0"
                      :href="session.doctor.resume_link"
                      target="_blank"
                      @click.stop
                  >
                    {{ $t('sessionCard.show_resume') }}
                  </v-btn>
                </div>
              </div>
              <div class="d-flex flex-column justify-center mr-2">
                <div>
                  <span style="color: #4597df">{{ $t('sessionCard.therapist_label') }}</span>
                  {{ doctorName }}
                </div>
                <div v-if="session.doctor.skype_link">
                  <v-btn
                      class="mt-2"
                      small
                      outlined
                      color="primary"
                      :href="session.doctor.skype_link"
                      target="_blank"
                      @click.stop
                  >
                    {{ $t('sessionCard.skype_link') }}
                    <v-icon class="mx-1">mdi-skype</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="statusLabel">
              <div class="actionArea d-flex mt-3 justify-end">
                <div class="ml-2 testSessionLabel">
                  تست های آنلاین روانشناسی
                </div>
                <img
                    width="23px"
                    height="23px"
                    :class="!$vuetify.rtl && 'en_arrow'"
                    src="../../assets/image/png/session/button_status.png"
                    style="border-radius: 5px"
                    alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    session: {
      type: Object,
      required: true,
    },
  },
  computed: {
    doctorName() {
      const doctor = this.session.doctor
      if (!doctor) return ''
      if (this.$vuetify.rtl) {
        return doctor.full_name
      }
      return `${doctor.en_name || ''} ${doctor.en_family || ''}`.trim() || doctor.full_name
    },
  },
}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 600px) {
  .sessionCard {
    padding: 10px !important;
  }

  .therapistName {
    font-size: 12px;
  }

  .actionArea {
    font-size: 12px !important;
  }
}

.therapistImage img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.sessionCard {
  width: 100%;
  min-height: 130px;
  background: white;
  border-radius: 18px;
  padding: 25px;
  border: 1px solid #3cbe8b;
  box-shadow: 0 1px 14px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.sessionCardInfo {
  padding-right: 5px;
}

.actionArea {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3cbe8b;
}

.testSessionLabel {
  font-weight: 700;
}
</style>
